import { AnalyticsTrigger, Button, Separator } from 'telia-front-react';
import * as React from 'react';
import { TranslationsContext } from '@telia-common-components/shared';
const CampaignButtons = (props) => {
    const { showTelia1CampaignButton } = props;
    const { translate } = React.useContext(TranslationsContext);
    if (!showTelia1CampaignButton) {
        return null;
    }
    const getCampaignButton = (text, url) => (React.createElement(Button, { text: text, iconLeft: "#file-pdf", link: true, target: "_blank", url: url, className: "text-small", iconClass: "text-primary" }));
    return (React.createElement(React.Fragment, null, showTelia1CampaignButton && (React.createElement(React.Fragment, null,
        React.createElement(AnalyticsTrigger, { trigger: {
                id: 'Link - InternetOffer - Telia 1 tingimused',
                callback: 'onClick',
            } }, getCampaignButton(translate('internetOffer.telia1Promo.terms'), translate('internetOffer.telia1Promo.terms.url'))),
        React.createElement(Separator, { color: "invisible", spacing: "xsmall" })))));
};
export default CampaignButtons;
